import { render } from "./QuickData.vue?vue&type=template&id=4845c8ef&ts=true"
import script from "./QuickData.vue?vue&type=script&lang=ts"
export * from "./QuickData.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__